/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2021-03-29 14:16:34
 * @LastEditors: yaozuo
 * @LastEditTime: 2021-11-04 15:07:57
 */

import { globalBeforeRouter, globalAfterRouter } from '@/common/router/base'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import ContributionList from './views/contribution-list/contribution-list.vue'

Vue.use(VueRouter)

export const routes: RouteConfig[] = [
  {
    name: 'HelpFeedback',
    path: '/help-feedback',
    component: () => import('./views/help-feedback/help-feedback.vue'),
    meta: {
      title: '帮助与反馈',
      auth: true,
      login: true,
      report: true,
      pageId: 'page_h5_help_feedback',
      pageName: '帮助与反馈',
      pageType: 'liveType'
    }
  },
  {
    name: 'HelpCommit',
    path: '/help-commit',
    component: () => import('./views/help-feedback/help-commit.vue'),
    meta: {
      title: '帮助与反馈',
      auth: true,
      login: true,
      report: true,
      pageId: 'page_h5_help_feedback',
      pageName: '帮助与反馈',
      pageType: 'liveType'
    }
  },
  {
    name: 'HelpDetail',
    path: '/help-detail',
    component: () => import('./views/help-feedback/help-detail.vue'),
    meta: {
      title: '问题详情'
    }
  },
  {
    name: 'HelpList',
    path: '/help-list',
    component: () => import('./views/help-feedback/help-list.vue'),
    meta: {
      title: '问题列表'
    }
  },

  {
    name: 'nullify',
    path: '/nullify',
    component: () => import('./views/nullify/index.vue'),
    meta: {
      title: '注销账号',
      auth: true,
      report: true,
      pageId: 'page_h5_Cancel_account',
      pageName: '注销账号',
      pageType: 'liveType'
    }
  },

  {
    path: '/richH5',
    component: () => import('./views/richTextH5/richTextH5.vue'),
    meta: {
      title: '',
      titleColor: '#000000',
      navColor: '#ffffff'
    }
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach(globalBeforeRouter)
router.afterEach(globalAfterRouter)
export default router
